// removed by extract-text-webpack-plugin
module.exports = {"forgotLink":"_2dog"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Auth/LoginForm/LoginForm.scss
// module id = aYKd
// module chunks = 0